export default "__VITE_ASSET__BvnbUM8V__"